import React, { useState } from 'react';
import { supabaseAuth } from '../supabaseClient';

const roles = [
  { key: 'lawyer', label: 'Lawyer', desc: 'Full access' },
  { key: 'paralegal', label: 'Paralegal', desc: 'Limited access' },
  { key: 'admin', label: 'Admin', desc: 'System access' },
];

export default function LoginPage({ onLogin, onCreateAccount, onBackToHome }: { onLogin: (user: any) => void; onCreateAccount: () => void; onBackToHome?: () => void }) {
  const [role, setRole] = useState('lawyer');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await supabaseAuth.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) setError(error.message);
    else onLogin(data.user);
  };

  const handleOAuth = async (provider: 'google' | 'azure') => {
    setError('');
    const { error } = await supabaseAuth.auth.signInWithOAuth({ provider });
    if (error) setError(error.message);
  };

  const handleResetPassword = async () => {
  if (!email) {
    setError("Please enter your email address first.");
    return;
  }
  
  const { error } = await supabaseAuth.auth.resetPasswordForEmail(email, {
    redirectTo: "https://casekaizen.com/reset-password", // changed to frontend URL
  });
  if (error) setError(error.message);
  else alert("🎉 Password reset email sent!\nPlease check your inbox.");
 };


  return (
    <div className="login-container">
      <button className="back-to-home-btn" onClick={onBackToHome || (() => window.location.href = '/')}>
        ← Back to Home
      </button>
      <div className="login-content">
        <div className="login-logo">
          <img src="/logo.png" alt="CaseKaizen Logo" className="logo-img" />
        </div>
        <div className="login-form-wrapper">
        <h2>Sign In</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />

          <div className="forgot-password">
            <a href="#" onClick={(e) => { e.preventDefault(); handleResetPassword(); }}>
              Forgot your password?
            </a>
          </div>

          {error && <div style={{ color: 'red', marginBottom: 8 }}>{error}</div>}
          <button type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <div className="oauth-divider">or continue with</div>
        <button className="oauth-btn google" onClick={() => handleOAuth('google')}>Continue with Google</button>
        <button className="oauth-btn microsoft" onClick={() => handleOAuth('azure')}>Continue with Microsoft</button>
        <div className="signup-link">
          Don't have an account? <a href="#" onClick={(e) => { e.preventDefault(); onCreateAccount(); }}>Create account</a>
        </div>
        </div>
      </div>
    </div>
  );
} 